import fetchWrapper from "../../helpers/fetchWrapper";
import { swalConfirm, swalError } from "../../../app/helpers/swal";
import {
  BarChartOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  ExportOutlined,
  FullscreenOutlined,
  FunnelPlotOutlined,
  HolderOutlined,
  TableOutlined,
} from "@ant-design/icons";
import { Card, Dropdown, Menu, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import { useRef } from "react";
import styled from "styled-components";
import exportChart from "./exportChart";
import React from "react";
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const WidgetCard = (props) => {
  const {
    cardTitle,
    handleOptionClick,
    children,
    widgetType,
    customiseWidgets,
    cardModuleId,
    cardUserId,
    userInfo,
    tblView,
    widgetId,
    moduleInfo,
  } = props;
  const filterTitle = <span style={{ fontSize: "10px" }}>Add Filter</span>;
  const fullscreenTitle = (
    <span style={{ fontSize: "10px" }}>View in full screen</span>
  );
  const tblTitle = <span style={{ fontSize: "10px" }}>Table View</span>;
  const chartTitle = <span style={{ fontSize: "10px" }}>Chart View</span>;
  const exportType = (e, widgetId, mid) => {
    if (e?.key === "downloadPdf" || e?.key === "downloadImg") {
      exportChart(e.key, exportRef.current, "chart");
    } else {
      // const userInfo = userService.userValue;
      if (moduleInfo === cardModuleId && userInfo.user_id === cardUserId) {
        widgetDelete(widgetId, mid);
      } else {
        swalError("Permision Denied!");
      }
    }
  };
  const exportRef = useRef();
  const history = useHistory();
  const itemsChart = [
    // getItem('Archive', 'sub1', <FileZipOutlined />),
    getItem("Export", "sub2", <ExportOutlined />, [
      getItem("PDF", "downloadPdf"),
      getItem("PNG", "downloadImg"),
    ]),
    customiseWidgets && getItem("Delete", "delete", <DeleteOutlined />),
  ];
  const widgetDelete = (widgetId, mid) => {
    swalConfirm("Are you sure  ?").then((result) => {
      const payLoad = { dashboard_widget_id: widgetId, module_id: 22 };
      if (result.isConfirmed) {
        fetchWrapper
          .patch("/dashboard/widget-configurations/remove", payLoad)
          .then((response) => {
            if (!response.error) {
              // swalSuccess(response.message);
              history.push({
                pathname: `/`,
              });
            } else {
              swalError(response.message);
            }
          })
          .catch((error) => {
            swalError(error.message);
          });
      }
    });
  };

  const menu = (
    <Menu
      // onClick={(e) => exportType(e, widgetId, moduleInfo.module_id)}
      onClick={(e) => exportType(e, widgetId, moduleInfo)}
      style={{
        width: 100,
        fontSize: "12px",
      }}
      mode="vertical"
      className="cardMenu"
      items={
        widgetType === "Card"
          ? itemsChart.filter((_, index) => index !== 2)
          : itemsChart
      }
    />
  );
  return widgetType === "CardV2" ? (
    <>
    {customiseWidgets && (
        <GrabIcon className="fa fa-bars" style={{ cursor: 'grab' }} />
    )}
    <TrashIcon className="fa fa-trash" style={{ zIndex:'1000'}} onClick={() => exportType(undefined, widgetId, moduleInfo)}></TrashIcon>
    <span ref={exportRef}>{children}</span>
  </>
  ) : (
    <CardWrapper
      title={
        <p className="mb-0" style={{ fontSize: '0.9vw' }}>
					{cardTitle}
				</p>
      }
      size="small"
      extra={
        <>
        
          {widgetType !== "Card" ? (
            <>
              {true && (
                  <Tooltip
                    placement="top"
                    title={filterTitle}
                    overlayClassName="custom-tooltip-title"
                  >
                    <FunnelPlotOutlined
                      style={{
                        fontSize: "15px",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOptionClick("filter", cardTitle)}
                    />
                  </Tooltip>
                )}
              <Tooltip
                placement="top"
                title={
                  !tblView
                    ? tblTitle
                    : tblView === widgetId
                    ? chartTitle
                    : tblTitle
                }
                overlayClassName="custom-tooltip-title"
              >
                {!tblView ? (
                  <TableOutlined
                    style={{
                      fontSize: "15px",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleOptionClick("tblView", cardTitle, widgetId)
                    }
                  />
                ) : tblView === widgetId ? (
                  <BarChartOutlined
                    style={{
                      fontSize: "15px",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleOptionClick("chartView", cardTitle, widgetId)
                    }
                  />
                ) : (
                  <TableOutlined
                    style={{
                      fontSize: "15px",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleOptionClick("tblView", cardTitle, widgetId)
                    }
                  />
                )}
              </Tooltip>
              <Tooltip
                placement="top"
                title={fullscreenTitle}
                overlayClassName="custom-tooltip-title"
              >
                <FullscreenOutlined
                  style={{
                    fontSize: "15px",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOptionClick("fullscreen", cardTitle)}
                />
              </Tooltip>
            </>
          ) : (
            ""
          )}

          <Dropdown overlay={menu} style={{ fontSize: "0.5vw" }}>
            <EllipsisOutlined
              style={{
                fontSize: "20px",
                marginLeft: "10px",
                cursor: "pointer",
              }}
            />
          </Dropdown>
          {customiseWidgets && (
						<span className="me-2">
							<i className="fa fa-bars" style={{ cursor: 'grab',fontSize: '17px', marginLeft:'3px', color:'rgba(0, 0, 0, 0.85)' }}></i>
						</span>
					)}
        </>
      }
    >
      <span ref={exportRef}>{children}</span>
    </CardWrapper>
  );
};
const TrashIcon = styled.i`
	position: absolute;
	right: 10px;
	bottom: 8%;
	transform: translateY(-50%);
	z-index: 2;
	cursor: pointer;
	font-size: 16px;
	color:rgba(0, 0, 0, 0.85);
	opacity: 0;
	transition: color 0.2s ease, transform 0.2s ease;
	.react-grid-item:hover & {
		/* color: darkred; */
		opacity: 1;
		transform: translateY(-50%) scale(1.1);
	}
`;
const GrabIcon = styled.i`
	position: absolute;
	right: 10px;
	top: 20px;
	transform: translateY(-50%);
	z-index: 2000;
	cursor: pointer;
	font-size: 16px;
	color:rgba(0, 0, 0, 0.85);
	opacity: 1;
`;
const CardWrapper = styled(Card)`
  height: 100%;
  box-shadow: none !important;
  .ant-card-body {
    height: 90%;
    padding-bottom: 10px !important;
  }
  .ant-card-head-title {
    /* margin-bottom: 0.725rem; */
  }
  .ant-card-head {
    padding: 0 15px;
  }
`;
export default WidgetCard;
